import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Lightning, Sparkle, Crown, Horse } from "@phosphor-icons/react";
import AppShell from "../components/AppShell";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WorldCupDarkHorses() {
    const [horses, setHorses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${API}/worldcup/dark-horses?limit=12`)
            .then((r) => setHorses(r.data.horses || []))
            .catch(() => toast.error("Failed to load dark horses"))
            .finally(() => setLoading(false));
    }, []);

    return (
        <AppShell>
            <section className="space-y-5">
                <Link to="/worldcup" className="font-mono text-[10px] uppercase tracking-widest text-white/40 hover:text-white inline-flex items-center gap-1.5">
                    <ArrowLeft size={11} weight="bold" /> Back to WC Hub
                </Link>

                <header className="border-2 border-[#F08080]/40 bg-[#0d0d0d] p-6" data-testid="wc-dark-horses-header">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F08080] flex items-center gap-2">
                        <Lightning size={11} weight="fill" />
                        Dark Horse Tracker
                    </div>
                    <h1 className="font-display font-black text-2xl md:text-3xl uppercase tracking-tight mt-2">
                        Outsider squads with breakout potential
                    </h1>
                    <p className="font-mono text-[11px] text-white/60 mt-3 leading-relaxed">
                        Scoring blends <strong>PL crossref players × 3</strong>, <strong>PL Top-50 value × 5</strong>, <strong>historical dark-horse +10</strong>, <strong>favourable MD1 +5</strong>. Top-tier nations (Argentina, Brazil, France…) are excluded — they aren't "dark" anything.
                    </p>
                </header>

                {loading ? (
                    <div className="font-mono text-[12px] text-white/40">Loading dark horses…</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="dark-horses-grid">
                        {horses.map((h, i) => (
                            <Link
                                to={`/worldcup/team/${h.team_id}`}
                                key={h.team_id}
                                className="border border-[#F08080]/20 bg-[#0d0d0d] hover:border-[#F08080]/60 transition-colors p-4 space-y-2"
                                data-testid={`dark-horse-${h.team_id}`}
                            >
                                <div className="flex items-baseline justify-between gap-2">
                                    <div>
                                        <span className="font-display font-black text-lg text-[#F08080] tabular-nums">#{i + 1}</span>
                                        <span className="font-display font-black text-xl text-white ml-2">{h.team_name}</span>
                                    </div>
                                    <span className="font-mono text-[10px] uppercase tracking-widest text-[#F08080] tabular-nums">
                                        {h.total_score} pts
                                    </span>
                                </div>
                                <div className="font-mono text-[10px] text-white/40 flex items-center gap-2 flex-wrap">
                                    <span>PL: <span className="text-fa-mint">{h.pl_count}</span> ({h.pl_top50_count} top-50)</span>
                                    {h.historical_dark_horse && <span className="border border-fa-yellow/40 text-fa-yellow px-1.5 py-0.5">HISTORICAL</span>}
                                    {h.favourable_md1 && <span className="border border-fa-mint/40 text-fa-mint px-1.5 py-0.5">EASY MD1</span>}
                                </div>
                                {h.top_picks?.length > 0 && (
                                    <div className="font-mono text-[10px] text-white/70 pt-1 border-t border-white/5">
                                        Top PL talent: {h.top_picks.map((p) => `${p.name} (#${p.rank})`).join(" · ")}
                                    </div>
                                )}
                                {h.md1_opponent && (
                                    <div className="font-mono text-[9px] uppercase tracking-widest text-white/30">
                                        MD1 vs {h.md1_opponent}
                                    </div>
                                )}
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </AppShell>
    );
}
